export default function erreurChampsVide(champsVide, champs, messagesChampsVide) {
  if (champsVide.some(c => {
    return c === champs;
  })) return;
  champsVide.push(champs);
  if (champsVide.length >= 2) {
    messagesChampsVide.splice(0, 1, 'validation.fieldsComplete');
    return;
  }
  messagesChampsVide.splice(0, 1, 'validation.fieldComplete');
}



// WEBPACK FOOTER //
// ./src/services/validation/erreurChampsVide.js